/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Why_LinkInputs */

const en_cp_why_link = /** @type {(inputs: Cp_Why_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the research and program summary in the docs`)
};

const id_cp_why_link = /** @type {(inputs: Cp_Why_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baca ringkasan riset dan program di dokumentasi`)
};

/**
* | output |
* | --- |
* | "Read the research and program summary in the docs" |
*
* @param {Cp_Why_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_why_link = /** @type {((inputs?: Cp_Why_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Why_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_why_link(inputs)
	return en_cp_why_link(inputs)
});